import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'post-component',
  templateUrl: 'post.component.html',
  standalone: false,
})
export class PostComponent implements OnInit {
  ngOnInit() {}
}
